<section class="curation-editor-wrapper" *ngIf="isDataLoaded">
  <gen-overlay-loader *ngIf="loading" class="curation-editor-overlay-loader"></gen-overlay-loader>
  <gen-curation-editor-header
    [curationItem]="curationItem"
    [curationStatus]="curationStatus"
    [revisionsData$]="revisionsData"
    [revisionName]="currentRevisionName"
    [readOnlyUserMode]="readOnlyUserMode"
    (revisionSelected)="revisionHistoryRowClick($event)"
    [revisionLastUpdatedDate]="revisionLastUpdatedDate"
    [lastManualOpinionName]="lastManualOpinionName"
  >
  </gen-curation-editor-header>
  <gen-curation-editor-actions
    [curationStatus]="curationStatus"
    [curationKey]="curationKey"
    [approvalUserMode]="approvalUserMode"
    [publishUserMode]="publishUserMode"
    [curatorUserMode]="curatorUserMode"
    [isAssignee]="isCurationItemAssignedToCurrentUser"
    [buttonsDisabled]="actionsDisabledMode"
    [curationItem]="curationItem"
    [oldRevisionMessage]="oldRevisionMessage"
    [readOnlyUserMode]="readOnlyUserMode"
    [multiStepReview]="multiStepReview"
    [newNotes]="newNotes"
    [reassignButtonDisabled]="isReassignButtonDisabled"
    [historyData]="revisionsData"
    (statusChanged)="changeStatus($event.status)"
    (statusChangedToRejected)="reject()"
    (goBackEvent)="goBack(true)"
    (notesPanelToggled)="toggleNotesPanel()"
    (toggleReassignCurationItem)="reassignCurationItem()"
    (toggleSubmitCurationItemForReview)="submitCurationItemForReview()"
    [sameOrganization]= "sameOrganization"
    [showStopWorkflowButton] = "showStopWorkflowButton"
    [showArchiveReason] = "showArchiveReason"
    (toggleShowArchiveReason)="viewArchiveReason()"
  >
  </gen-curation-editor-actions>
  <gen-panel
          name="CURATION-NOTES-PANEL"
          class="{{notesPanelClass}}"
          (toggleDisplayStatusChanged)="toggleDisplayStatusChanged($event)">
  </gen-panel>
  <section class="scrollable">
    <section class="curation-editor-content" [ngClass]="curationStatus" *ngIf="isDataLoaded">
      <span class="titles">Clinical Trial Details</span>
      <gen-dynamic-form
        [listenToDataChange]="true"
        [formData]="formData"
        [formName]="formName"
        [disabled]="readOnlyMode"
        [formVertical]="true"
        [updateOnBlur]="false"
        [updatedFieldsContext]="updatedFieldsContext"
        [submitted]="submitted"
        [editMode]="false"
        (formChange)="updateForm($event.form)"
        [disabledFields]="disabledField"
        (validateChange)="validationEvent($event)">
      </gen-dynamic-form>
    </section>
  </section>
</section>
